export const home_i18n = {
    text1: "Envie seu primeiro check-in para assinatura",
    text2: "O check-in virtual coleta os dados biométricos do hóspede e os vincula à sua reserva.",
    text3: "Enviar Check-in",
    text4: 'Início',
    text5: "Check-in",
    text6: "Bem-vindo",
    text7: "Configuração do check-in",
    text8: "minha conta",
    text9: "Configuração do check-in",
    text10: "Sair",
    text11: "Imagem do hotel",
    text12: "Políticas do hotel",
    text13: "mensagens de boas-vindas",
    text14: "Envie o logo do seu hotel",
    text15: "Selecione ou arraste o logo",
    text16: "Cancelar",
    text17: "Nome do hotel",
    text18: "Salvar alterações",
    text19: "Alterar logo",
    text20: "Baixar",
    text21: "Histórico de assinaturas",
    text22: "Painel de controle dos documentos assinados pelos hóspedes.",
    text23: "Filtrar:",
    text24: "Desativado",
    text25: "Por data",
    text26: "Por país",
    text27: "Nome",
    text28: "Sobrenome",
    text29: "Nacionalidade",
    text30: "Data do check-in",
    text31: "Sincronizado",
    text32: "Opções",
    text33: "Sem dados",
    text34: "Linhas por página:",
    text35: "Buscar",
    text36: "Países",
    text37: "De",
    text38: "Até",
    text39: "COPYRIGHT © 2022 , Todos os direitos reservados WACheckines",
    text40: "Feito com",
    text41: "Exportar",
    text42: "Ver detalhe",
    text43: "Ver PDF assinado",
    text44: "Excluir",
    text45: "Selecione uma opção",
    //aca
    text46: "Adicionar uma forma de pagamento",
    text47: "Cadastre ou atualize a forma de pagamento na qual as cobranças mensais serão feitas.",
    text48: "Dívida total",
    text49: "Pagamento realizado com sucesso",

    p1: "Você está na versão de teste",
    p2: "Você tem",
    p3: "dias restantes!",
    p4: "O período de teste terminou.",
    p5: "Assine agora",
    p6: "Seu período de teste gratuito terminou!",

};
